export default (props) => (
  <header style={props.style}>
    <style jsx>{`
      header {
        background-image: url(${props.bg});
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: cover;
        max-width: 100%;
        height: 0;
        padding-bottom: 56%;
        overflow: hidden;
        position: relative;
        background-attachment: fixed;
      }

      @media (min-width: 768px) and (max-width: 1200px) {
        header {
          background-attachment: initial;
          background-image: url(${props.mobile_bg});
          padding-bottom: 177.78%;
        }
      }

      @media(max-width: 768px){
        header {
          background-attachment: initial;
          background-image: url(${props.mobile_bg});
          padding-bottom: 177.78%;
        }
      }

      @media only screen and (min-width: 1366px) and (orientation: landscape) {
        header {
          background-attachment: initial;
        }
      }

      @media only screen and (min-width: 1024px) and (orientation: landscape) {
        header {
          background-attachment: initial;
          background-image: url(${props.bg});
          padding-bottom: 56%;
        }
      }
    `}</style>
  </header>
)